/** @format */
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';

const _ = require('underscore');

export class RmoListHelper {
    private static list: Array<HeaderCheckBoxSelectListElement> = [
        { name: 'simcard:rmo.model_null', value: -1 },
        { name: 'simcard:rmo.model_a', value: 1 },
        { name: 'simcard:rmo.model_b', value: 2 },
        { name: 'simcard:rmo.model_c', value: 3 },
    ];

    public static getList = (): Array<HeaderCheckBoxSelectListElement> => {
        return RmoListHelper.list;
    };

    public static getName = (id: number): string | null => {
        const obj = _.find(RmoListHelper.list, (st: HeaderCheckBoxSelectListElement) => {
            return st.value === id;
        });
        if (obj) {
            return obj.name;
        }
        return null;
    };
}
